<script>
import gql from "graphql-tag";
import { onLogin } from "../vue-apollo";
import provider from "../libs/provider";
import Bugsnag from '@bugsnag/js';
export default {
	apollo: {
		settings: {
			query: gql`
				{
					Settings {
						has_completed_wizard
						connected
					}
				}
			`,
			update: r => r.Settings
		}
	},

	mounted() {
		if (this.$route.query.code || provider.get().providerCode === "msft") {
			const isOrg = localStorage.getItem('isOrg') === "true" ? true : false;
			if(isOrg) {
				localStorage.removeItem("isOrg");
			}
			this.$apollo
				.mutate({
					mutation: gql`
						mutation ExchangeThirdPartyAuthCode($code: String!, $isOrg: Boolean!) {
							ExchangeThirdPartyAuthCode(code: $code, isOrg: $isOrg)
						}
					`,
					variables: {
						code: this.$route.query.code || "",
						isOrg: isOrg
					},
					update: (store, { data: ExchangeThirdPartyAuthCode }) => {

						const routeToUse = isOrg ? "organisation.schools" : "directory";

						if(provider.get().providerCode === "msft") {
							this.$router.push({ name: !this.settings.has_completed_wizard ? "wizard.settings" :  routeToUse});
						}
						else if (ExchangeThirdPartyAuthCode) {
							// replace apollo-token with an updated one containing the user's provider id
							onLogin(this.$apollo.vm.$apolloProvider.clients.defaultClient, ExchangeThirdPartyAuthCode.ExchangeThirdPartyAuthCode);
							this.$router.push({ name: !this.settings.has_completed_wizard ? "wizard.settings" : routeToUse });
						} else {
				 			this.$message.error("Something went wrong, please try again.");
							this.$router.push({ name: "connect" });
						}
					}
				})
				.catch(e => {
					Bugsnag.notify(e, (event) => {
						event.errors[0].errorClass = "ExchangeThirdPartyAuthCodeError";
					});
					this.$message.error("Failed to connect, please try again or contact support.");
					this.$router.push({ name: "connect" });
				});
		} else {
			this.$message.error("Something went wrong, please try again.");
			this.$router.push({ name: "connect" });
		}
	}
};
</script>
